
// src/pages/COM/COM110M1.jsx
import React, {useEffect, useState} from 'react';
import {postData} from "utils/TransactionUtil";


import styleCom from "../RE/REGCOM.module.scss";
import Table from "../../components/Table/Table";
import InputUnitText from "components/InputText/InputUnitText";
import toast from "../../components/Toast/Toast";
import Button from "../../components/Button/Button";


const COM110M1 = ({handle_Close, userId, comHandleClick_Save}) => {


    let [userDtl, setUserDtl] = useState({
        lginId:userId,  userPw:'',  userNewPw1:'', userNewPw2:''
    });


    const [chkPass, setChkPass] = useState("");

    /* Event ==================================================================================================== */

    function checkEssential2() {

        let result = true;

        // 2.신규 패스워드 체크
        const idRegEx =  /^(?=.*[A-Za-z])(?=.*\d)(?=.*[!@#$%^&*])[A-Za-z\d!@#$%^&*]{8,16}$/;
        const validatePw = (pw) => {
            return idRegEx.test(pw);
        };

        if(!validatePw(userDtl.userNewPw1)){
            result=false;
            toast({ type: 'warning', message: '패스워드 규칙을 확인해주세요.'});
        }else if(userDtl.userNewPw1 !== userDtl.userNewPw2){
            result=false;
            toast({ type: 'warning', message: '패스워드/확인값이 다릅니다.'});
        }else if(userDtl.lginId === ""){
            result=false;
            toast({ type: 'warning', message: '작업 대상ID를 확인할 수 없습니다.'});
        }else if(userDtl.userPw === userDtl.userNewPw2){
            result=false;
            toast({ type: 'warning', message: '기존 패스워드는 사용할 수 없습니다.'});
        }
        return result;
    }



    /* Call Service====================================================================================================*/

    async function preAuthCheck() {
        const param = {
            userId : userDtl.lginId,
            userPw : userDtl.userPw
        }

        try{
            let result = await postData("/preAuthCheck", param);
            //setChkPass(result.passCheck);
            return result.passCheck;
        }catch (e) {
            setChkPass("N");
            return "N";
        }

    }

    async function svcSecurePwReset() {

        //사용자 등록
        let result = await postData("/MSU/setUserPwChange", userDtl);
        handle_Close();
        toast({ type: 'info', message: '암호 변경이 완료되었습니다.'});
    }

    // ------------------------------------------------
    const handleMainSave = () => {

        preAuthCheck().then((chkPass) => {
            if(chkPass!=="Y"){
                toast({ type: 'warning', message: '현재 패스워드를 확인해주세요.'});
            }else if(checkEssential2()){
                svcSecurePwReset();
            }
        });
    }

    return(
        <>
            <div className={styleCom.main_wrap} style={{marginBottom: "10px"}}>

                <Table variant='default' rowCnt={4} colSize={['30%', '70%']} rowSize={'56px'}>
                    <div>사용자 ID</div>
                    <div>
                        {userId}
                    </div>
                    <div>현재암호</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userPw}
                                       onChange={(value) => setUserDtl({...userDtl, userPw: value})}/>
                    </div>


                    <div>패스워드</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userNewPw1}
                                       onChange={(value) => setUserDtl({...userDtl, userNewPw1: value})}/>
                        <div style={{color: "gray", fontSize: "12px"}}>
                            8~16자(영문/숫자/특수문자를 혼합하여 사용하십시오)
                        </div>
                    </div>
                    <div>패스워드 확인</div>
                    <div>
                        <InputUnitText type={"password"} maxLength={20}
                                       value={userDtl.userNewPw2}
                                       onChange={(value) => setUserDtl({...userDtl, userNewPw2: value})}/>
                    </div>

                </Table>
            </div>

            <div className={styleCom.search_wrap}>
                <Button variant="Primary" size="md" addStyle={{width: "200px", height: "40px"}}
                        onClick={() => handleMainSave()}>
                    패스워드 변경(저장)
                </Button>
            </div>
        </>
    )
}
export default COM110M1;